// extracted by mini-css-extract-plugin
module.exports = {"free-demo-button":"css_free-demo-button__2tVPr","alone-button":"css_alone-button__19DXm","large":"css_large__j3yV4","mobile":"css_mobile__lXmvD"};